import * as React from 'react';
export class FloatingRenderer extends React.PureComponent {
    render() {
        return React.createElement("div", { style: { display: 'grid', gridTemplateRows: 'minmax(min-content, max-content) 1fr' } },
            React.createElement(this.props.floatyRenderers.floatingTabRenderer, { floatyManager: this.props.floatyManager, stackItem: this.props.floating }),
            React.createElement(this.props.floatyRenderers.floatingContentRenderer, { floatyManager: this.props.floatyManager, stackItem: this.props.floating }));
    }
}
//# sourceMappingURL=floating-renderer.js.map